module.exports = __tmimport("~endpoint:{controller: \'customized/api\', action: \'apply_methods\'}");